import Phaser from 'phaser';

const ALPHA_TOLERANCE = 24;

export function bindGeodePixelHit(sprite: Phaser.GameObjects.Image) {
  sprite.setInteractive({
    pixelPerfect: true,
    alphaTolerance: ALPHA_TOLERANCE,
  });
}

export function isPointerOnGeode(
  scene: Phaser.Scene,
  sprite: Phaser.GameObjects.Image,
  pointer: Phaser.Input.Pointer,
  fallback: { cx: number; cy: number; radius: number },
  { blockedBy }: { blockedBy?: (pointer: Phaser.Input.Pointer) => boolean } = {},
): boolean {
  if (!sprite.visible || !sprite.active) return false;
  if (blockedBy?.(pointer)) return false;

  if (sprite.input?.enabled) {
    const hits = scene.input.hitTestPointer(pointer);
    if (hits.includes(sprite)) return true;
  }

  const dx = pointer.worldX - fallback.cx;
  const dy = pointer.worldY - fallback.cy;
  return dx * dx + dy * dy <= fallback.radius * fallback.radius;
}
